import GlossaryList from './GlossaryList';

export default GlossaryList;
